import { CasinoThemeEnum, ThemeFeatureUIConfig } from '@frontend/casino-ui/shared';

export const themeConfig: ThemeFeatureUIConfig = {
    [CasinoThemeEnum.Mgm4]: {
        navbar: {
            pill: { inverse: true, variant: 'strong' },
            notificationBubble: { inverse: true, variant: 'neutral' },
            buttonIcon: { inverse: true, variant: 'outline' },
        },
    },
    [CasinoThemeEnum.Coral]: {
        navbar: {
            pill: { inverse: true, variant: 'strong' },
            notificationBubble: { inverse: true, variant: 'neutral' },
            buttonIcon: { inverse: true, variant: 'outline' },
        },
    },
    [CasinoThemeEnum.Bwin]: {
        navbar: {
            pill: { inverse: true, variant: 'strong' },
            notificationBubble: { inverse: true, variant: 'neutral' },
            buttonIcon: { inverse: true, kind: 'secondary', variant: 'outline' },
        },
    },
    [CasinoThemeEnum.BwinDark]: {
        navbar: {
            pill: { inverse: false, variant: 'strong' },
            notificationBubble: { inverse: false, variant: 'neutral' },
            buttonIcon: { inverse: false, kind: 'secondary', variant: 'outline' },
        },
    },
    [CasinoThemeEnum.SportingbetBr]: {
        navbar: {
            pill: { inverse: false, variant: 'subtle' },
            notificationBubble: { inverse: false, variant: 'neutral' },
            buttonIcon: { inverse: false, kind: 'tertiary', variant: 'outline' },
        },
    },
    [CasinoThemeEnum.BetbooBr]: {
        navbar: {
            pill: { inverse: false, variant: 'subtle' },
            notificationBubble: { inverse: false, variant: 'neutral' },
            buttonIcon: { inverse: false, kind: 'tertiary', variant: 'outline' },
        },
    },
};
